import PrimaryModal from 'components/common/PrimaryModal/PrimaryModal';
import styles from './UserDashboardV1.module.scss';

type Props = {
    videoTitle: string;
    videoUrl: string;
    open: boolean;
    onClose: () => void;
};

const VideoModal = ({ open, onClose, videoUrl, videoTitle }: Props) => {
    return (
        <>
            {open && (
                <PrimaryModal open={open} onClose={onClose} modalStyle={{ zIndex: '10000' }}>
                    <div>
                        {/* <div className="flex justify-center"> */}
                        <iframe
                            src={videoUrl}
                            className={styles.userVideo}
                            allow="fullscreen"
                            title={videoTitle}
                        ></iframe>
                        {/* </div> */}
                    </div>
                </PrimaryModal>
            )}
        </>
    );
};

export default VideoModal;
